import { viewStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsView";
import { css } from "styled-components";

viewStyles.leftColumnGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        overflow: hidden;
        direction: ltr;
    `,
};

viewStyles.rightColumnGridItem = {
    width: [0, 0, 6, 6, 6],
    css: css`
        padding-right: 5px;
        > div {
            > div {
                > .promoMessage {
                    ~ .modelNumber {
                        padding-bottom: 25px;
                        @media all and (max-width: 768px) and (min-width: 0px) {
                            padding-bottom: 18px;
                        }
                        > div {
                            > div:nth-child(1) {
                                @media all and (max-width: 992px) and (min-width: 768px) {
                                    flex-basis: calc(100% - 22.667%);
                                    max-width: calc(100% - 22.667%);
                                }
                            }
                            > div:nth-child(2) {
                                @media all and (max-width: 992px) and (min-width: 768px) {
                                    flex-basis: 22.666667%;
                                    max-width: 22.666667%;
                                }
                            }
                        }
                    }
                }
                > div:not(.promoMessage):first-child {
                    ~ div:nth-child(2) {
                        padding-bottom: 25px;
                        @media all and (max-width: 768px) and (min-width: 0px) {
                            padding-bottom: 18px;
                        }
                        > div {
                            > div:nth-child(1) {
                                @media all and (max-width: 992px) and (min-width: 768px) {
                                    flex-basis: calc(100% - 22.667%);
                                    max-width: calc(100% - 22.667%);
                                }
                            }
                            > div:nth-child(2) {
                                @media all and (max-width: 992px) and (min-width: 768px) {
                                    flex-basis: 22.666667%;
                                    max-width: 22.666667%;
                                }
                            }
                        }
                    }
                }
            }
        }
        .priceCartWrapper {
            padding: 0px 9px 0px 20px !important;
            div[class^="GridItemStyle"] {
                flex-basis:40% !important;
                max-width:40% !important;
            }
            div[class^="FormFieldStyle"]{
                margin:13px 0px;
            }
            button[data-test-selector^="addProductToCart"] {
                width:180px !important;
                margin:13px 0px;
                span {
                    font-size: 12px;
                    font-weight: 600;
                    letter-spacing: 2px;
                    text-align: center;
                    text-transform: uppercase;

                }
            }
        }
    `,
};

viewStyles.middleGridItem = {
    width: [12, 12, 0, 0, 0],
    css: css`
        padding: 0 36px;
        > div {
            > div {
                > div:nth-child(2) {
                    padding-bottom: 25px;
                    > div {
                        > div:nth-child(1) {
                            // flex-basis: 66.5%;
                            // max-width: 66.5%;
                            margin-top: 2px;
                        }
                    }
                }
            }
        }
        .qtyCartWrapper {
            padding:0px 9px 0px 15px !important;
            div[class^="GridItemStyle"]{
                &:nth-child(1) {
                flex-basis:40% !important;
                max-width:40% !important;
                    div[class^="FormFieldStyle"]{
                        margin:13px 0px;
                    }
                    label {
                        flex-basis:35% !important;
                        max-width:35% !important;
                    }
                    div[class^="FormInputWrapper"]{
                        flex-basis:50% !important;
                        max-width:50% !important;
                    }
                }
                &:nth-child(2){
                    flex-basis:60% !important;
                    max-width:60% !important;
                    button {
                        margin:13px 0px;
                        padding: 0px 15px !important;
                    }
                }
            }
        }
    `,
};
